import { useContext, useState, useEffect, useCallback, useRef } from 'react';
import TenantContext from '../../contexts/tenantContext';
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box';
import notify from 'devextreme/ui/notify';

import { useFiltriDataSource, useFilterBuilderFieldsDataSource, useAnteprimaDataSource } from '../../datasources/FilterBuilderDataSource';
import React from 'react';
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Editing,
    Form,
    Button as GridButton,
    Toolbar,
    Item as GridItem,
    DataGridRef,
    Popup
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import PopupFilterEdit, { FilterEditPopupHandle } from '../../components/filterEdit/FilterEditPopup';
import { ColumnButtonClickEvent } from 'devextreme/ui/data_grid';

export default function Filtri() {
    const dataSource = useFiltriDataSource();
    const popupFilterEditRef = useRef<FilterEditPopupHandle>(null);
    const gridRef = useRef<DataGridRef>(null);

    function openFiltroEditPopup(e: ColumnButtonClickEvent) {
        popupFilterEditRef.current?.edit(e.row?.key);
    }

    function openFiltroNewPopup() {
        popupFilterEditRef.current?.new();
    }

    const refreshGrid = () => gridRef.current?.instance().refresh();

    return (
        <React.Fragment>
            <h2 className={'content-block'}>Filtri</h2>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>

                    <DataGrid
                        dataSource={dataSource}
                        ref={gridRef}
                        onDataErrorOccurred={dataGridErrorHandling}
                        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
                    >
                        <Editing
                            allowUpdating={true}
                            allowAdding={true}
                            allowDeleting={true}>
                        </Editing>
                        <Column type='buttons' alignment='left'>
                            <GridButton name="edit" onClick={openFiltroEditPopup} />
                            <GridButton name="delete" />
                        </Column>
                        <Column dataField="nome" caption="Nome filtro" />

                        {/* <Column
                            dataField="espressione"
                            caption="Espressione"
                            cellRender={e => typeof e.value === 'string' ? e.value : JSON.stringify(e.value)}
                            minWidth={200}
                        /> */}

                        <Toolbar>
                            <GridItem location="after">
                                <Button
                                    icon='add'
                                    hint='Crea un nuovo filtro'
                                    stylingMode="text"
                                    onClick={openFiltroNewPopup}
                                />

                            </GridItem>
                        </Toolbar>
                    </DataGrid>

                </div>
            </div>

            <PopupFilterEdit ref={popupFilterEditRef} onDataChanged={refreshGrid} />
        </React.Fragment>
    );
}


